import { Component, OnInit } from "@angular/core";
import { MenuController, NavController, Platform } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { SupportService } from "./services/support/support.service";
import { PatchNotesService } from "./services/patchNotes/patch-notes.service";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SwUpdate } from "@angular/service-worker";
import { AuthService } from "./services/auth/auth.service";
import { EventsService } from "./services/events/events.service";
import { FunctionsService } from "./services/functions/functions.service";
import { SosService } from "./services/sos/sos.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  menu: any[];
  public onlineOffline: boolean = navigator.onLine;

  public logoutItem: any = {
    title: "LOGOUT",
    url: "/login",
    icon: "../assets/icons/menu/logout.svg",
    open: false,
    children: [],
    roles: [],
  };
  automaticClose = true;
  public dashboardUpdate = false;
  public versionNumber = 0;
  private swUpdateInProgress = false;

  constructor(
    public auth: AuthService,
    public eventsServ: EventsService,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public menuCtrl: MenuController,
    private navCtrl: NavController,
    private translate: TranslateService,
    private router: Router,
    private http: HttpClient,
    private swUpdate: SwUpdate,
    public supportServ: SupportService,
    private notesServ: PatchNotesService,
    private funcServ: FunctionsService,
    private sosServ: SosService,
  ) {
    this.initializeApp();
    if (!navigator.onLine) {
      this.funcServ.showToast("¡Sin conexión!", "secondary");
    }
    window.addEventListener("offline", () => {
      this.funcServ.showToast("¡Sin conexión!", "secondary");
    });
    window.addEventListener("online", () => {
      this.funcServ.showToast("En linea", "success");
    });
  }

  initializeApp() {
    if (this.platform.is("ios") || this.platform.is("android")) {
      this.platform.ready().then(() => {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
      });
    }
  }

  ngOnInit() {
    this.enableMenu(false);
    this.initializeApp();
    this.initServiceWorkerUpdates();
    this.initTranslate();
    this.listenToLoginEvents();
  }

  initServiceWorkerUpdates() {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    // Evita bucles de recarga: solo se procesa una actualización a la vez.
    this.swUpdate.available.subscribe(async () => {
      if (this.swUpdateInProgress) {
        return;
      }
      this.swUpdateInProgress = true;
      try {
        await this.swUpdate.activateUpdate();
        window.location.reload();
      } catch (error) {
        this.swUpdateInProgress = false;
        console.error("Error actualizando service worker", error);
      }
    });

    // Si otra pestaña activa una versión nueva, recarga una sola vez.
    this.swUpdate.activated.subscribe(() => {
      if (this.swUpdateInProgress) {
        return;
      }
      this.swUpdateInProgress = true;
      window.location.reload();
    });

    this.checkForServiceWorkerUpdate();

    setInterval(() => this.checkForServiceWorkerUpdate(), 30 * 60 * 1000);
  }

  private checkForServiceWorkerUpdate() {
    this.swUpdate.checkForUpdate().catch(() => null);
  }

  getAlerts() {
    this.sosServ.getAlerts().subscribe((res) => {
      this.sosServ.activeAlerts = res;
      if (res.length > this.sosServ.countAlerts) {
        this.ActiveStrobo();
      }
      this.sosServ.countAlerts = res.length;
    });
  }

  ActiveStrobo() {}

  getVersion() {
    this.notesServ.getApps().subscribe((apps) => {
      const aux: any = document.getElementsByTagName("META");
      if (apps && apps.length > 0) {
        apps.forEach((a) => {
          if (a.id === "dashboard") {
            for (let i = 0; i < aux.length; i++) {
              if (aux[i].name === "version") {
                this.versionNumber = Number(aux[i].content);
                if (this.versionNumber < Number(a.version)) {
                  this.dashboardUpdate = true;
                }
              }
            }
          }
        });
      }
    });
  }

  refreshPage() {
    window.location.reload();
  }

  logOut() {
    this.eventsServ.nextUserPublish("logout");
  }

  listenToLoginEvents() {
    this.eventsServ.nextUserGetObservable("login").subscribe(() => {
      this.initMenu();
      if (this.auth.currentUser.value && this.auth.currentUser.value.roles) {
        if (this.auth.currentUser.value.roles.admin) {
          this.getAlerts();
        }
        if (
          this.auth.currentUser.value.roles.admin ||
          this.auth.currentUser.value.roles.admin_support ||
          this.auth.currentUser.value.roles.customer_support ||
          this.auth.currentUser.value.roles.root
        ) {
          this.supportServ.loadTickets();
        }
      }
      if (this.router.url === "/login") {
        this.router.navigate(["/home"]);
      }
      console.log(this.router.url);
      if (
        this.router.url.includes("acc") ||
        this.router.url.includes("download") ||
        this.router.url.includes("event") ||
        (this.router.url.includes("t") && this.router.url.length === 1) ||
        this.router.url.includes("m-v") ||
        this.router.url.includes("invitation") ||
        this.router.url.includes("invitacion") ||
        this.router.url.includes("privacy-policy") ||
        this.router.url.includes("help") ||
        (this.router.url.includes("support") && this.router.url.length === 7) ||
        this.router.url.includes("menu") ||
        this.router.url.includes("parking") ||
        this.router.url.includes("manual") ||
        (this.router.url.includes("devices") && this.router.url.length === 7) ||
        this.router.url.includes("payment") ||
        this.router.url.includes("coupon") ||
        this.router.url.includes("404") ||
        this.router.url.includes("forbidden")
      ) {
        console.log("em-F");
        this.enableMenu(false);
      } else {
        // console.log('opppppppppppppppp');
        this.enableMenu(true);
        // this.router.navigate(['/home']);
        // this.router.navigate(['/users/lBvM3oi5v3NO1I5tsq256pFazTu2/cards/new']);
        // this.router.navigate(['/users/all/subscriptions/new']);
        // this.router.navigate(['/event/Q4YWaSoHkUyX4nWLqOAd']);
        // this.router.navigate(['/reports/access']);
        // this.router.navigate(['/manager/QupcBZVMSgdQO7PynsJY/residents']);
        // this.router.navigate(['/installations/QupcBZVMSgdQO7PynsJY']);
        // this.router.navigate(['/users']);
      }
    });
    this.eventsServ.nextUserGetObservable("logout").subscribe((r) => {
      console.log(r);
      this.auth.signOut();
      this.navCtrl.navigateRoot(["/login"]).then((re) => {
        console.log(re);
        setTimeout(() => {
          this.enableMenu(false);
        }, 500);
      });
    });

    this.eventsServ.nextUserGetObservable("guest").subscribe((r) => {
      console.log(r);
      this.initMenu();
      this.enableMenu(false);
    });
  }

  initMenu() {
    this.http.get("assets/data/menu.json").subscribe((res) => {
      if (res["items"]) {
        this.menu = res["items"];
        this.menu[0].open = true;
      }
    });
    // }
  }

  closeAllMenus() {
    if (this.menu.length > 0) {
      this.menu.forEach((m) => {
        m.open = false;
      });
    }
  }

  toggleSection(index) {
    this.menu[index].open = !this.menu[index].open;
    if (this.automaticClose && this.menu[index].open) {
      this.menu
        .filter((item, itemIndex) => itemIndex !== index)
        .map((item) => (item.open = false));
    }
  }

  toggleItem(index, childIndex) {
    this.menu[index].children[childIndex].open =
      !this.menu[index].children[childIndex].open;
    this.menu[index].children.forEach((ce, ci) => {
      if (ci !== childIndex) {
        ce.open = false;
      }
    });
  }

  enableMenu(loggedIn: boolean) {
    this.menuCtrl.enable(loggedIn, "cMenu");
  }

  initTranslate() {
    this.translate.setDefaultLang("es");
    const browserLang = this.translate.getBrowserLang();
    if (browserLang) {
      if (browserLang === "zh") {
        const browserCultureLang = this.translate.getBrowserCultureLang();

        if (browserCultureLang.match(/-CN|CHS|Hans/i)) {
          this.translate.use("zh-cmn-Hans");
        } else if (browserCultureLang.match(/-TW|CHT|Hant/i)) {
          this.translate.use("zh-cmn-Hant");
        }
      } else {
        this.translate.use(this.translate.getBrowserLang());
      }
    } else {
      this.translate.use("es");
    }
  }
}
